// extracted by mini-css-extract-plugin
export var scrollArea = "_n8-0";